import { render, staticRenderFns } from "./mktPaginateList.vue?vue&type=template&id=6c374333&"
import script from "./mktPaginateList.vue?vue&type=script&lang=js&"
export * from "./mktPaginateList.vue?vue&type=script&lang=js&"
import style0 from "../mktPagination.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports